<template>
  <v-layout row wrap class="no-toppad" no-gutters text-xs-right>
    <v-container>
      <v-row noGutters>
        <v-col cols="12" md="12" sm="12">
          <div class="sections-container">
            <div class="modern-form">
              <div class="form-container">
                <div class="section-header">
                  <h2 class="section-title">Communication Preferences</h2>
                </div>
                <div class="preferences-form">
                  <div class="preference-group">
                    <v-checkbox 
                      v-model="smsMarketingOptIn" 
                      label="Education & Updates Text" 
                      class="preference-checkbox"
                      hide-details>
                    </v-checkbox>
                    <v-checkbox 
                      v-model="smsReminderOptIn" 
                      label="Reminder Text" 
                      class="preference-checkbox"
                      hide-details>
                    </v-checkbox>
                    <v-checkbox 
                      v-model="emailMarketingOptIn" 
                      label="Education & Updates Emails" 
                      class="preference-checkbox"
                      hide-details>
                    </v-checkbox>
                    <v-checkbox 
                      v-model="emailReminderOptIn" 
                      label="Reminder Emails" 
                      class="preference-checkbox"
                      hide-details>
                    </v-checkbox>
                  </div>
                
                  <div class="form-actions">
                    <v-btn
                      class="btn-primary"
                      @click="saveCommPreference()"
                      :loading="isSubmitting">
                      Save
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>
<script>
import DataService from '../../../_services/DataService';
export default {
  name: 'contact-preferences',
  data() {
    return {
      pageName: 'Contact Preferences',
      isSubmitting: false,
      smsMarketingOptIn: true,
      smsReminderOptIn: true,
      emailMarketingOptIn: true,
      emailReminderOptIn: true,
    };
  },
  methods: {
    async getData() {
      const response = await DataService.getPatientContactPreferences();
      if (response.status === 200) {
        const { sms, email } = response.data;
        this.smsMarketingOptIn = !sms.marketing.optOut;
        this.smsReminderOptIn = !sms.reminders.optOut;
        this.emailMarketingOptIn = !email.marketing.optOut;
        this.emailReminderOptIn = !email.reminders.optOut;
      }
    },

    async saveCommPreference() {
      try {
        this.isSubmitting = true;
        const response = await DataService.setPatientContactPreferences({
          sms: {
            marketing: { optOut: !this.smsMarketingOptIn },
            reminders: { optOut: !this.smsReminderOptIn },
          },
          email: {
            marketing: { optOut: !this.emailMarketingOptIn },
            reminders: { optOut: !this.emailReminderOptIn },
          },
        });

        if (response.status === 200) {
          this.$root.$emit('raise_alert', {
            color: 'success',
            text: 'Communication preferences updated successfully',
          });
        } else {
          this.$root.$emit('raise_alert', {
            color: 'error',
            text: response.data || 'Something went wrong',
          });
        }
      } catch (err) {
        this.$root.$emit('raise_alert', {
          color: 'error',
          text: 'Something went wrong',
        });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  async mounted() {
    await this.getData();
  },
};
</script>

<style lang="scss">
.preferences-form {
  .preference-group {
    margin-bottom: 24px;
    
    .preference-checkbox {
      margin-bottom: 16px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
